<template>
	<div class="home">
		<navComponent/>
		<div class="container">
			<div class="row" style="margin-top: 10%">
				<div class="col-sm-6 d-none d-sm-block text-center">
					<div style="margin:5%">
						<img src="../assets/global.svg" alt="" style="width: 350px; height:350px; border-radius: 50%;">
						<h5 style="margin: 5% 0; text-align: left"><b>Verification is required, to know who you are mate?</b></h5>
					</div>
				</div>
				<div class="col-12 col-sm-6 card">
					<div class="container text-center card-body">
						<h2><b>Verify</b></h2>
						<br>
						<div v-if="setPasswordUser.errors.length > 0">
							<div
								v-for="(a,i) in setPasswordUser.errors"
								:key="i"
								class="alert alert-danger"
							>{{ a }}</div>
						</div>
						<p class="mb-0">We have sent you an email along with 4 digit verification code. Please enter that code to validate.</p>
						<p class="text-danger"><b>(Don't forget to check in your Spam/Junk folder.)</b></p>
						<div class="form-group">
							<label for="otp"  style="float:left">Verification Code</label>
							<input
								type="text"
								v-model="setPasswordUser.otp"
								class="form-control form-control-sm"
								id="otp"
								placeholder="Verification Code"
								required
							/>
						</div>
						<div class="form-group">
							<label for="password" style="float:left">Set a Password</label>
							<input
								type="password"
								v-model="setPasswordUser.password"
								class="form-control form-control-sm"
								id="password"
								aria-describedby="passwordHelp"
								placeholder="Password"
								required
							/>
						</div>
						<div class="form-group">
							<label for="confirm-password" style="float:left">Confirm Password</label>
							<input
								type="password"
								v-model="setPasswordUser.confirmPassword"
								class="form-control form-control-sm"
								id="confirm-password"
								aria-describedby="passwordHelp"
								placeholder="Confirm Password"
								required
							/>
						</div>
						<button type="submit" @click="verifyUser" class="btn btn-primary" style="margin-bottom: 20px">Verify</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import navComponent from '@/components/nav.vue'
  export default {
    name: 'home',
    data() {
      return {
        setPasswordUser: {
          otp:"",
          password: "",
          confirmPassword: "",
          errors: []
        }
      }
    },
    components: {
      navComponent,
    },
    methods: {
      setPassword() {
        let $ = this;
        console.log($.setPasswordUser);
        $.setPasswordUser.errors = [];
        if (
          $.setPasswordUser.password &&
          $.setPasswordUser.password.length >= 6 &&
          $.setPasswordUser.password === $.setPasswordUser.confirmPassword
        ) {
          return true;
        }
        if ($.setPasswordUser.password === "") {
          $.setPasswordUser.errors.push("Password is required");
          return false;
        }
        if ($.setPasswordUser.password.length < 6) {
          $.setPasswordUser.errors.push(
            "Length of password must be greater than 6"
          );
          return false;
        }
        if ($.setPasswordUser.password !== $.setPasswordUser.confirmPassword) {
          console.log("Not matching");
          $.setPasswordUser.errors.push(
            "Passwords are not matching"
          );
          return false;
        }
      },
      verifyUser(){
        const $ = this
	      if ($.setPassword()){
          $.$store.dispatch("verifyUser", $.setPasswordUser).then(resp => {
            if (resp.data.status === 'success') {
              console.log('Move to Home')
              $.$toast.open({
                message: "Account verified and now you can create or join any events.",
                type: "success",
				position: "top",
				queue: true
              });
              localStorage.setItem("user_info", JSON.stringify(resp.data.data));
              $.$router.push('/dashboard')
            }else {
              $.$toast.open({
                message: resp.data.data,
                type: "error",
				position: "top",
				queue: true
              });
            }
          })
	      }
      },
    },
    created() {
      // window.addEventListener("beforeunload", function(event) {
      //   event.returnValue = "Write something clever here..";
      // });
      console.log('Created');
    }
  }
</script>

<style scoped>
	h6 {
		width: 100%;
		text-align: center;
		border-bottom: 1px solid rgb(87, 81, 81);
		line-height: 0.1em;
		margin: 10px 0 20px;
	}

	h6 span {
		background: #1b1b1b;
		padding: 0 10px;
	}
</style>

